import createSliders from './create-slider.js';

function init() {
    const options = {
        spaceBetween: 12,
        slidesPerView: 'auto',
        watchOverflow: true,
        watchSlidesProgress: true,
        freeMode: true,
    };

    createSliders('js_promisesSlider', options);
}

$(document).ready(init);
